import type { Ref } from 'react';
import { forwardRef } from 'react';
import FormLabel, { FormLabelVariant } from './FormLabel';
import TextArea from './TextArea';
import type { TextAreaProps } from './TextArea';

export type LabeledTextAreaProps = TextAreaProps & {
  /**
   * Optionally provide a variant which the label should be. You shouldn't ever need to use this, unless the design specifically calls for this variant. Otherwise we should use default styling everywhere.
   */
  labelVariant?: FormLabelVariant;
};

/**
 * Wraps a TextArea with a label. Displays the label above the <textarea />, with optional required text.
 */
const LabeledTextArea = forwardRef<HTMLTextAreaElement, LabeledTextAreaProps>(
  (
    { label, isRequired, labelVariant = FormLabelVariant.Default, ...textAreaProps }: LabeledTextAreaProps,
    ref: Ref<HTMLTextAreaElement>,
  ) => (
    <FormLabel label={label} requiredText={isRequired ? '(Required)' : undefined} variant={labelVariant}>
      <TextArea
        ref={ref}
        label={label}
        isRequired={isRequired}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...textAreaProps}
      />
    </FormLabel>
  ),
);

export default LabeledTextArea;
